/**
 * @generated SignedSource<<45c5c29b92d8807a3d1b42b8c0bf2889>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TextIntroductionField_User$data = {
  readonly profile: {
    readonly textIntroduction: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "TextIntroductionField_User";
};
export type TextIntroductionField_User$key = {
  readonly " $data"?: TextIntroductionField_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"TextIntroductionField_User">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TextIntroductionField_User",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "textIntroduction",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "bcf432f73383200832f4a70ac3fe5451";

export default node;
